import React, { useContext } from "react";
import FormContainer from "../../Components/Form/FormContainer";
import * as yup from "yup";
import { ApiLogin } from "../../services/api";
import { CredentialsType } from "../../global/types/user";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  HOME_ROUTE,
  REGISTRATION_REQUEST_ROUTE,
} from "../../global/constants/routes/defaultConstants";
import { RECOVERY_PASSWORD_ROUTE } from "../../global/constants/routes/userConstants";
import styled from "styled-components";
import logo from "../../Components/Navbar/assets/logo.svg";
import { useErrorToast } from "../../hooks/useErrorToast";
import { toast } from "sonner";
import { Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "../../Components/ui/shadcn/forms/field";
import { Input } from "../../Components/ui/input";
import { Button } from "../../Components/ui/buttons/button";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const LeftSide = styled.div`
  width: 40%;
  background-image: url("/frame.svg");
  background-size: cover;
  background-position: right;
  background-color: #fdfdfd;
`;

const RightSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fdfdfd;
`;

const loginActionLinkClassName = "cursor-pointer w-fit self-end pl-1";

const loginValidationSchema = yup.object({
  email: yup
    .string()
    .email("Entre com um email válido")
    .required("O email é nescessário"),
  password: yup.string().required("A senha é necessária"),
});

export const Login: React.FC = () => {
  const { login } = useContext(AuthContext);
  const errorToast = useErrorToast();
  const navigate = useNavigate();

  const handleLogin = async (values: CredentialsType) => {
    try {
      const { message } = await ApiLogin(values, login);
      toast.success(message);
      navigate(HOME_ROUTE);
    } catch (error) {
      errorToast((error as Error).message);
    }
  };

  const form = useForm<CredentialsType>({
    resolver: yupResolver(loginValidationSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  return (
    <Container>
      <LeftSide />
      <RightSide>
        <div style={{ alignSelf: "center" }}>
          <img
            src={logo}
            alt="logo"
            style={{ width: "250px", height: "auto" }}
          />
        </div>
        <FormContainer
          onSubmit={handleLogin}
          submitLabel="Entrar"
          methods={form}
        >
          <Typography variant="h5" alignSelf="baseline">
            Login
          </Typography>
          <FieldGroup>
            <Controller
              name="email"
              control={form.control}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="form-login-email">E-mail</FieldLabel>
                  <Input
                    {...field}
                    id="form-login-email"
                    aria-invalid={fieldState.invalid}
                    placeholder="email@email.com"
                    autoComplete="off"
                    type="email"
                  />
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            />
            <Controller
              name="password"
              control={form.control}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel htmlFor="form-login-password">Senha</FieldLabel>
                  <Input
                    {...field}
                    id="form-login-password"
                    aria-invalid={fieldState.invalid}
                    placeholder="Digite sua senha"
                    type="password"
                    autoComplete="off"
                  />
                  {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                  )}
                </Field>
              )}
            />
          </FieldGroup>
          <div className="flex w-full flex-col gap-1">
            <div className="flex w-full justify-between">
              <Button
                type="button"
                asChild
                className={loginActionLinkClassName}
                variant="link"
              >
                <a href={REGISTRATION_REQUEST_ROUTE}>Cadastre-se</a>
              </Button>
              <Button
                type="button"
                asChild
                className={loginActionLinkClassName}
                variant="link"
              >
                <a href={RECOVERY_PASSWORD_ROUTE()}>Recuperar senha</a>
              </Button>
            </div>
          </div>
        </FormContainer>
      </RightSide>
    </Container>
  );
};
